// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Header----header-module---container---2zoPp","logoAndMenu":"src-components-Header----header-module---logoAndMenu---3AYJ5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.less
// module id = 264
// module chunks = 114276838955818